import { graphql, useStaticQuery } from "gatsby";
import { OutboundLink } from "gatsby-plugin-google-gtag";
import Fb from "images/facebook-gcff01b15e_640.png";
import Ig from "images/instagram-g425d4841f_640.png";
import * as React from "react";
import { InfoPageHero } from "../components/layout/info-hero";
import { Layout } from "../components/layout/layout";
import { LocationType } from "../interfaces";

function Contact({ location }: { location: LocationType }) {
    const data: {
        content: {
            title: string;
            description: string;
            text: string;
            mail: string;
            fbLink: string;
            igLink: string;
        };
    } = useStaticQuery(graphql`
        {
            content: articlesJson(key: { eq: "contact" }) {
                title
                description
                text
                mail
                fbLink
                igLink
            }
        }
    `);

    return (
        <Layout
            path="/contact/"
            title={data.content.title}
            description={data.content.description}
        >
            <InfoPageHero title={data.content.title} centered={true} />

            <div className="p-8 pb-0 text-center text-2xl">
                <p dangerouslySetInnerHTML={{ __html: data.content.text }} />
                <div className="h-8" />
                <address>
                    <a
                        className="not-italic transition-colors duration-500 hover:text-red-500"
                        href={`mailto:${data.content.mail}`}
                    >
                        {data.content.mail}
                    </a>
                </address>
                <div className="h-8" />

                <div className="flex justify-center gap-10">
                    <OutboundLink href={data.content.fbLink} target="_blank">
                        <img className="h-10 w-10" src={Fb} alt={""} />
                    </OutboundLink>
                    <OutboundLink href={data.content.igLink} target="_blank">
                        <img className="h-10 w-10" src={Ig} alt={""} />
                    </OutboundLink>
                </div>
            </div>
        </Layout>
    );
}
export default Contact;
